/* eslint-disable max-len */
import React from 'react'

const WarningIcon = () => (
  <span className="svg-icon-warning">
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFB946"
          stroke="#333B40"
          strokeWidth="2.769"
          d="M18 1.385C8.824 1.385 1.385 8.824 1.385 18c0 9.176 7.439 16.615 16.615 16.615 9.176 0 16.615-7.439 16.615-16.615 0-9.176-7.439-16.615-16.615-16.615z"
        />
        <path
          fill="#2C383E"
          strokeWidth="2.769"
          d="M16.062 9.692h4.153l-.778 10.633H16.84l-.78-10.633zm4.153 14.55a2.077 2.077 0 11-4.153 0 2.077 2.077 0 014.153 0z"
        />
      </g>

    </svg>
  </span>
)

export default WarningIcon
